export default __webpack_public_path__ + "static/kofe2-f8ba2d769215d2d05db3e6d3bcf45e2a.svg";